/* global delighted */
import axios from "axios";

export default async () => {
	const response = await axios.get("/shadow");
	const { email, name, createdAt, shouldSurvey, ...properties } = response.data;

	if (shouldSurvey) {
		delighted.survey({
			email,
			name,
			createdAt,
			properties,
		});
	}
};
